import type { PromoConfig } from 'shared/lib/promo/common';

export type FeaturesResponse = {
  promo?: PromoConfig[];
  flags?: {
    /**
     * shows sandbox switch for individual companies
     */
    sandbox_switch_individual_company?: boolean;

    /**
     * shows coverage request button & modal
     */
    coverage_request?: boolean;

    /**
     * shows paygo refresh button
     */
    show_paygo_refresh?: boolean;
  };
};

export enum FeatureFlag {
  KNOCK_NOTIFICATIONS = 'knock-notifications',
  RESETTABLE_FILTERS = 'resettable-filters',
  UPLOAD_ORDERS_ASSETS = 'upload-orders-assets',
  CONVERSION_RATE_REPORT = 'conversion-rate-report',
}

export enum FeatureFlagVariant {
  CONTROL = 'control',
  ALTERNATIVE = 'alternative',
}
